import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StudentsComponent} from './students/students.component';
import {UniversitiesComponent} from './universities/universities.component';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {ProgrammesComponent} from './programmes/programmes.component';
import {IncomingStudentsComponent} from './incoming-students/incoming-students.component';
import {TooltipModule} from 'primeng/primeng';
import {DataTablesModule} from 'angular-datatables';
import {PocsComponent} from './pocs/pocs.component';


@NgModule({
    imports: [CommonModule, NgbModalModule, FormsModule, TooltipModule, DataTablesModule],
    declarations: [UniversitiesComponent, StudentsComponent, ProgrammesComponent, IncomingStudentsComponent, PocsComponent]
})
export class DataManagementModule {
}
